import React, { useState } from "react";

type ToggleSwitchProps = {
	rtext?: string;
	ltext?: string;
    id?:string|number;
	status:boolean;
	setToggle: (e:boolean, id: unknown)=>void;
};

function ToggleSwitch({ rtext, ltext, id, status, setToggle }: ToggleSwitchProps) {
	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.stopPropagation(); 
		setIsChecked(!isChecked);
        setToggle(!isChecked, id);
		
		
	};

	return (
		<>
			<label className="themeSwitcherTwo relative inline-flex cursor-pointer select-none items-center" id="TOOGLE">
				<input
				    id="TOGGLE"
					type="checkbox"
					name="toggle"
					checked={isChecked || status}
					onChange={(e)=>handleCheckboxChange(e)}
					className="sr-only"
				/>
				<span className="label flex items-center text-lg font-medium text-gray-500" id="TOGGLE">
					{ltext}
				</span>
				<span id="TOGGLE"
					className={`slider mx-4 flex h-[1.5rem] w-[3rem] items-center rounded-full p-1 duration-200 ${
						isChecked || status ? "bg-primary-70" : "bg-[#CCCCCE]"
					}`}
				>
					<span id="TOGGLE"
						className={`dot h-[1rem] w-[1rem] rounded-full bg-white duration-200 ${
							isChecked || status ? "translate-x-[28px]" : ""
						}`}
					></span>
				</span>
				<span className="label flex items-center text-sm font-medium text-black" id="TOOGLE">
					{rtext}
				</span>
			</label>
		</>
	);
}
export default ToggleSwitch;
